<template>
  <div>
    <span v-if="task.discarded">
        <QuickTaskCheckbox v-if="this.task.kind == 'todo'" :task="task"/>
        <i v-if="this.task.kind == 'document'" class="material-icons">description</i>
        <span v-html="generateTelLinks(titleContent())" style="white-space: pre-line;"></span>
        <QuickTaskIcons v-if="this.task.kind == 'todo' || this.task.kind == 'document'" :task="task"/>
    </span>
    <span v-else>
      <span v-if="titleEditing">
        <textarea-autosize class="form-control" v-model="titleText" @blur.native="blur" @focus="focus"></textarea-autosize>
      </span>
      <span v-else>
        <QuickTaskCheckbox v-if="this.task.kind == 'todo'" :task="task"/>
        <i v-if="this.task.kind == 'document'" class="material-icons">description</i>
        <span v-html="generateTelLinks(titleContent())" @mousedown="focus" style="white-space: pre-line;"></span>
        <QuickTaskIcons v-if="this.task.kind == 'todo' || this.task.kind == 'document'" :task="task"/>
      </span>
    </span>
  </div>
</template>

<script>
import api from "api";
import QuickTaskCheckbox from "components/QuickTaskCheckbox";
import QuickTaskIcons from "components/QuickTaskIcons";


export default {
  components: {
    QuickTaskCheckbox,
    QuickTaskIcons,
  },
  props: {
    task: {
      type: Object
    },
    containerExpanded: {
      type: Boolean
    },
    titleEditing: {
      type: Boolean
    }
  },
  data() {
    return {
      titleText: this.task.title,
    };
  },
  watch: {
    containerExpanded(){
      if(!this.containerExpanded){
        this.saveTitle();
        this.$parent.titleEditing = false
      }
    }
  },
  methods: {
    titleContent(){
      if(this.titleText.trim() == ''){
        return 'Add a Title'
      } else if(this.containerExpanded){
        return this.titleText
      } else {
        return this.titleText.length > 75 ? `${this.titleText.substring(0, 75)}...` : this.titleText;
      }
    },
    saveTitle(){
      this.$parent.titleEditing = false;
      if(this.titleText != this.task.title){
        api.updateTask(this.task.id, { title: this.titleText }).then(response => {
        });
      }
    },
    blur(event){
      this.saveTitle()
    },
    focus(event){
      if(this.containerExpanded){
        this.$parent.titleEditing = true;
      }
    }
  }
}
</script>
